// removed by extract-text-webpack-plugin
module.exports = {"root":"root__3P9NT","text":"text__3oB9X","reasonsWrap":"reasonsWrap__2zMeC","reasons":"reasons__3dgvc","heart":"heart__3A_2f","inView":"inView__1LH6w","bg":"bg__Wbdpq","medium":"medium__2ddqE","large":"large__2L4e2"};


//////////////////
// WEBPACK FOOTER
// ./components/BreakupMosaic/style.css
// module id = tNlp
// module chunks = 0